'use strict';

define(['utils/underscore', 'utils/helpers'], function (_, utils) {
    var Preview = function Preview(_model) {
        this.model = _model;

        _model.on('change:playlistItem', onPlaylistItem, this);
        _model.on('change:mediaModel', onMediaModel, this);
    };

    function onMediaModel(model, mediaModel) {
        mediaModel.off('change:mediaType', null, this);
        mediaModel.on('change:mediaType', function (mediaModel, mediaType) {
            if (mediaType === 'audio') {
                this.setImage(model.get('playlistItem').image);
            }
        }, this);
    }

    function onPlaylistItem(model, playlistItem) {
        var delayPosterLoad = model.get('autostart') && !utils.isMobile() || model.get('item') > 0;

        if (delayPosterLoad) {
            this.setImage(null);
            model.off('change:state', null, this);
            model.on('change:state', function (model, state) {
                if (state === 'complete' || state === 'idle' || state === 'error') {
                    this.setImage(playlistItem.image);
                }
            }, this);
            return;
        }

        this.setImage(playlistItem.image);
    }

    _.extend(Preview.prototype, {
        setup: function setup(element) {
            this.el = element;
            var playlistItem = this.model.get('playlistItem');
            if (playlistItem) {
                this.setImage(playlistItem.image);
            }
        },
        setImage: function setImage(img) {
            // Remove onload function from previous image
            var image = this.image;
            if (image) {
                image.onload = null;
                this.image = null;
            }
            this.model.off('change:state', null, this);
            var backgroundImage = '';
            if (_.isString(img)) {
                backgroundImage = 'url("' + img + '")';
                image = this.image = new Image();
                image.src = img;
            }
            // IE8 下面预览图填充播放器兼容－效果等同background-size: 100% 100%
            // zhangzhe 2017-01-13
            if (utils.isPoorIE()) {
                this.el.style.filter = 'progid:DXImageTransform.Microsoft.AlphaImageLoader(src="' + img + '",sizingMethod="scale"';
            } else {
                utils.style(this.el, {
                    backgroundImage: backgroundImage
                });
            }
        },
        resize: function resize(width, height, stretching) {
            if (stretching === 'uniform') {
                var playerAspectRatio = width / height;
                // snap image to edges when the difference in aspect ratio is less than 9%
                var image = this.image;
                var backgroundSize = null;
                if (image) {
                    if (image.width === 0) {
                        var _this = this;
                        image.onload = function () {
                            _this.resize(width, height, stretching);
                        };
                        return;
                    }
                    var imageAspectRatio = image.width / image.height;
                    if (Math.abs(playerAspectRatio - imageAspectRatio) < 0.09) {
                        backgroundSize = 'cover';
                    }
                }
                utils.style(this.el, {
                    backgroundSize: backgroundSize
                });
            }
        },
        element: function element() {
            return this.el;
        }
    });

    return Preview;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/view/preview.js
 ** module id = 199
 ** module chunks = 0
 **/